import bilAPI from '../api';

export const getYears = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/core/exam_years/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          // Pass the real error through — it is what tells the caller whether
          // this was a 401, a network drop or a server error.
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getExamDates = (year) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/core/exam/`, { params: { year } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error');
        });
    } catch (error) {
      reject('system error');
    }
  });
};
